import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { CommonModal } from "@app/components/modals/CommonModal";
import { accountSchema } from "@app/pages/settings/Account/accountSchema";
import { passwordValidation } from "@app/utils/validation";
import { Button, useModal } from "@shortsworks/ui";
import {
  useGetAccount,
  useGetAccountPlatform,
  useResetPassword,
  useGetUserInfo,
} from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import { Suspense, useEffect } from "react";
import { passwordSchema } from "@app/pages/settings/Account/passwordSchema";

// 비밀번호를 위한 form 분리 필요
export const AccountSettings = () => {
  const { showModal } = useModal();

  const getAccount = useGetAccount();
  const getAccountPlatform = useGetAccountPlatform();
  const {
    data: userInfoData,
    isSuccess: isSuccessGetUserInfo,
    isLoading: isLoadingGetUserInfo,
  } = useGetUserInfo();

  const resetPassword = useResetPassword();

  const accountForm = useFormWithSchema({
    formSchemas: accountSchema,
    mode: "onChange",
  });

  const passwordForm = useFormWithSchema({
    formSchemas: passwordSchema,
    mode: "onChange",
  });

  useEffect(() => {
    if (!isSuccessGetUserInfo) return;
    const { email, name } = userInfoData.data;
    accountForm.setFormValues({ email, name });
  }, [isSuccessGetUserInfo]);

  const changePassword = async () => {
    if (!isSuccessGetUserInfo) return;

    const parsedForm = passwordForm.parseForm();
    const { email } = userInfoData.data;

    if (!parsedForm.success) {
      return;
    }

    const { newPassword, confirmPassword } = parsedForm.data;
    if (newPassword !== confirmPassword) {
      return showModal(CommonErrorModal, {
        title: "새로운 비밀번호와 비밀번호 확인이 일치하지 않습니다.",
      });
    }

    // 확인하기 이전에 알리도록 변경 필요
    if (!passwordValidation.test(newPassword)) {
      return showModal(CommonErrorModal, {
        title: "비밀번호 형식이 옳바르지 않습니다.",
      });
    }
    const result = await resetPassword.mutateAsync({
      data: {
        email,
        password: newPassword,
      },
    });

    // 해당 결과값에 대한 성공처리 변경 필요
    //@ts-ignore
    if (typeof result.data?.accessToken === "undefined") {
      return showModal(CommonErrorModal, {
        title: "비밀번호 변경에 실패했습니다.",
      });
    }

    showModal(CommonModal, { title: "비밀번호가 변경되었습니다." });
    return passwordForm.setFormValues({ newPassword: "", confirmPassword: "" });
  };

  if (!isSuccessGetUserInfo) {
    return (
      <div className="flex w-full h-full items-center justify-center">
        <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
      </div>
    );
  }

  return (
    <MainContentContainer>
      <MainHeader>
        <MainTitle>회원 정보</MainTitle>
        <MainDescription>회원 정보를 관리할 수 있습니다.</MainDescription>
      </MainHeader>
      <MainContent>
        <div className="max-w-[640px]">
          <div>
            <Suspense>
              <FormContainer
                schemas={accountForm.schemas}
                form={accountForm.form}
              />
              <div className="mt-4" />
              <FormContainer
                schemas={passwordForm.schemas}
                form={passwordForm.form}
              />
            </Suspense>
            <Button className="mt-4" type="submit" onClick={changePassword}>
              변경하기
            </Button>
          </div>
        </div>
      </MainContent>
    </MainContentContainer>
  );
};
